import Vue from 'vue'
import Datepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

const datepickerOptions = {
  colors: {
    selected: '#fd6700',
    inRange: '#ffcf94',
    selectedText: '#202020',
    text: '#202020',
    inRangeBorder: '#964b00',
    disabled: '#b1b1b1',
    hoveredInRange: '#fd8d31'
  }
}
Vue.use(Datepicker, datepickerOptions)
